import { FC, useContext, useEffect, useRef, useState } from "react";
import { CallTheFacilitatorOption, InitalChatMessage } from "../../molecules";

import { SocketContext, TeamContext, UserContext } from "../../../context";

import { useWindowDimensions, useSound } from "../../../hooks";
import { IMessage, IPlayer } from "../../../interfaces";
import { Phase } from "../../../util/enums";
import { useTranslation } from "react-i18next";

type TOrderOfFacilitatorNotification = 1 | 2 | 3 | 4 | 5 | 6;

interface IChatMolecule {
	shouldTheFirstMessageBeShown: boolean;
}

const ChatMolecule: FC<IChatMolecule> = ({ shouldTheFirstMessageBeShown }) => {
	const { t } = useTranslation();
	const { chatSocketOn, chatSocketOff, chatMessages, setChatMessages, timeParser } = useContext(SocketContext);
	const { game, sendMessage } = useContext(TeamContext);
	const { userData } = useContext(UserContext);

	const [insertedMessage, setInsertedMessage] = useState<string>("");
	const inputEl = useRef(document.createElement("div"));
	const { height } = useWindowDimensions();
	const {playSound} = useSound();
	const lobbyChatBodyHeight = height * 0.795 - 80;
	const boardChatBodyHeight = height * 0.695 - 80;
	const chatBodyHeight = shouldTheFirstMessageBeShown ? lobbyChatBodyHeight : boardChatBodyHeight;

	useEffect(() => {
		chatSocketOn();
	}, [chatSocketOn])

	useEffect(() => {
		if (chatMessages.length){
			const lastMessageSent = chatMessages[chatMessages.length - 1]; 

			if (lastMessageSent.float === "floatLeft")
				playSound("/sounds/MessageReceived2.mp3");
			
		} 
	
	}, [chatMessages, playSound]);

	useEffect(() => {
		let localCurrentElementValue = inputEl.current;
		let scrollHeightTimeout: any;

		if (game?.phase !== Phase.SLOT_MACHINE) {
			scrollHeightTimeout = setTimeout(() => {
				const scroll =
					localCurrentElementValue.scrollHeight -
					localCurrentElementValue.clientHeight;
				localCurrentElementValue.scrollTo(0, scroll);
			}, 50);
		}

		return () => {
			chatSocketOff();
			clearTimeout(scrollHeightTimeout);
		}
	}, [chatMessages, chatSocketOff, chatSocketOn, game?.phase]);

	const change = (event: any) => {
		setInsertedMessage(event.target.value);
	};

	const sendmessage = () => {
		if (insertedMessage) {
			sendMessage({ message: insertedMessage });
			setInsertedMessage("");
			playSound("/sounds/MessageSent.mp3");

			const currentTime = new Date();
			const formatedDate =
				timeParser(currentTime.getHours()) +
				":" +
				timeParser(currentTime.getMinutes());

			const localData: IMessage = {
				date: formatedDate,
				name: userData?.fullName || "",
				message: insertedMessage,
				float: "floatRight",
				email: userData?.email || ""
			}

			setChatMessages([...chatMessages, localData]);
			
		}
	}

	const handleKeyPress = (event: any) => {
		if (event.key === "Enter") {
			sendmessage();
		}
	}

	const listOfFacilitatorNotifications: TOrderOfFacilitatorNotification[] = [1,2,3,4,5,6];

	const renderFacilitatorMessages = () => {
		return (
			<div>
				{listOfFacilitatorNotifications.map( (element: TOrderOfFacilitatorNotification, index: number) => {
					return <CallTheFacilitatorOption orderOfFacilitatorNotification={element} key={index} />
				})}
			</div>
		)
	}

	return (
		<div className={`chat_molecule_wrapper ${!shouldTheFirstMessageBeShown && "chat_molecule_wrapper_pop_up_animation"}`}>
			<div className="order_element_vertically">
				<div style={{ height: "100%" }}>
					<div
						className="chat_body custom_scrollbar custom_made_scrollbar"
						ref={inputEl}
						style={{ height: `${chatBodyHeight}px` }}
					>
						{shouldTheFirstMessageBeShown && <InitalChatMessage normalText={t("helloAndThanksForPlayingText")} boldText={t("uppinessUpYourGameAtWorkText")} displayAfter={2000}/>}
						{shouldTheFirstMessageBeShown && <InitalChatMessage normalText={t("welcomeToTeamText")} boldText={game?.nickname?.concat(".") || ""} displayAfter={4000}/>}
						{shouldTheFirstMessageBeShown && <InitalChatMessage normalText={t("pleaseUploadYourText")} boldText={t("profilePictureText")} displayAfter={6000}/>}
						{shouldTheFirstMessageBeShown && <InitalChatMessage normalText={t("onThisScreenYouCanText")} boldText={t("changeYourNicknameText")} displayAfter={8000}/>}
						{shouldTheFirstMessageBeShown && <InitalChatMessage normalText={t("onThisScreenYouCanEditTheText")} boldText={t("teamNameText")} displayAfter={10000}/>}
						{shouldTheFirstMessageBeShown && <InitalChatMessage normalText={t("pleaseWaitForAllThePlayersToGetToThatLobbyScreenText")} boldText={t("theGameWillBeginText")} displayAfter={12000}/>}

						{!shouldTheFirstMessageBeShown && renderFacilitatorMessages() }

						{chatMessages.map((chatMessage: any, index: number) => {
							if (chatMessage.float === "floatRight") {
								return (
									<div className="message_row display_flex_end" key={index}>
										<div className="my_chat_message">
											<div className="chat_message_message_wrapper">
												<div className="chat_message_senders_message center_vertically">
													{" "}
													{chatMessage.message}{" "}
												</div>
											</div>
										</div>
									</div>
								);
							} 
							
							return (
								<div className="message_row" key={index}>
									<div className="chat_message_from_others">
										<div className="chat_message_image_wrapper">
											<img
												className={`chat_image border_color_${game?.players.find((player: any) => { return player.email === chatMessage?.email })?.color}`}
												src={`${process.env.REACT_APP_BACKEND_URL}images/${chatMessage?.email}.png`}
												alt="senders"
											/>
										</div>
										<div className="chat_message_message_wrapper">
											<div className="chat_message_senders_name">
												{" "}
												{game?.players.find((player: IPlayer) => { return player.email === chatMessage.email })?.nickname}{" "}
											</div>
											<div className="chat_message_senders_message center_vertically">
												{" "}
												{chatMessage.message}{" "}
											</div>
										</div>
									</div>
								</div>
							);
							
						})}
					</div>
				</div>
				<div style={{ height: "80px" }}>
					<div className="chat_separation_line"></div>
					<div className="chat_chat">
						<div className=" chat_input_field_wrapper">
							<input
								id="msg"
								style={{ color: "#005776" }}
								value={insertedMessage}
								onKeyPress={handleKeyPress}
								autoComplete="off"
								type="text"
								onChange={change}
								placeholder={t("enterAMessageText")}
								maxLength={600}
								required
								className="chat_input_field"
							/>
						</div>

						<div className=" chat_text_area_button" onClick={sendmessage}>
							<div className="chat_send_button_img"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChatMolecule;
